import { render, staticRenderFns } from "./FacialInfoModal.vue?vue&type=template&id=2a2b8d7e&scoped=true&"
import script from "./FacialInfoModal.vue?vue&type=script&lang=js&"
export * from "./FacialInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./FacialInfoModal.vue?vue&type=style&index=0&id=2a2b8d7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2b8d7e",
  null
  
)

export default component.exports